<template>
  <b-modal id="update" hide-footer>
    <template v-slot:modal-title>Editar Tipo de Agendamento</template>
    <div class="d-block">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <LabelRequiredField label="Nome" />
            <input
              type="text"
              v-model="schedule_type.name"
              class="form-control"
            />
          </div>

          <div class="col-md-12">
            <LabelRequiredField label="Status" />
            <select v-model="schedule_type.active" class="form-control">
              <option :value="1">Ativo</option>
              <option :value="0">Inativo</option>
            </select>
          </div>

          <ErrorsMessages :errors="errors" />

          <div class="col-md-12 text-right">
            <v-btn
              :disabled="loading"
              type="submit"
              class="v-success"
              @click="update"
            >
              <span class="fa fa-check"></span>
              {{ loading ? "Carregando" : "Salvar" }}
            </v-btn>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import ErrorsMessages from "../components/ErrorsMessages";
import LabelRequiredField from "../components/LabelRequiredField";
import api from "../../services/api";
import toast from "../../components/ToastNotification";

export default {
  name: "UpdateModal",

  props: {
    schedule_type: {
      type: Object,
      required: true,
    },
  },

  components: {
    LabelRequiredField,
    ErrorsMessages,
  },

  data() {
    return {
      errors: [],

      loading: false,
    };
  },

  methods: {
    async update() {
      try {
        this.loading = true;

        const id = this.schedule_type.id;
        const name = this.schedule_type.name;
        const active = this.schedule_type.active;

        let params = {
          id,
          name,
          active,
        };

        const response = await api.put("/admin/schedule/update", params);

        const { error, errors, message } = response.data;

        if (!error) {
          this.$bvModal.hide("update");

          toast(message, "success");

          this.errors = [];

          this.$emit("update", "schedule_type");
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
  },
};
</script>